import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"

export const topReportApi = createApi({
  reducerPath: "topReportApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/analytics" }),
  endpoints: builder => ({
    getAllPerformers: builder.query<any, any>({
      query: params => ({
        url: "all-performers",
        params,
      }),
    }),
  }),
})

export const { useGetAllPerformersQuery } = topReportApi
